<template>
  <div style="padding: 5px;">
    <a-card style="border: 0;">
      <a-row :gutter="[16, 16]">
        <a-col :sm="12" :md="4">
          <MyAvatar />
        </a-col>
        <a-col :sm="12" :md="18">
          <a-card style="border: 0; margin-top: -30px;">
            <a-row :gutter="[16, 16]">
              <a-col :sm="24" :md="12">
                <MyInfo :loadingItem="false" />
              </a-col>
              <a-col :sm="24" :md="12">
                <MyLeaveDay />
                <br />
                <MyLeaveSick />
              </a-col>
            </a-row>
            <a-divider />
            <MyAccount />
          </a-card>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import MyInfo from "./components/myInfo";
import MyAvatar from "./components/myAvatar";
import MyAccount from "./components/myAccount";
import MyLeaveDay from "./components/myLeaveDay";
import MyLeaveSick from "./components/myLeaveSick";

export default {
  components: { MyInfo, MyAvatar, MyAccount, MyLeaveDay, MyLeaveSick },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
